import React from 'react';
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
} from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { PdfTemplate } from '../../../../../types';
import TemplateCard from './TemplateCard';

// Helper function to convert snake_case to Title Case
const formatTemplateType = (type: string): string => {
  return type
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

interface TemplateGroupProps {
  type: string;
  templates: PdfTemplate[];
  documents: any[];
  parseExtractedFields: (fields: string | string[] | undefined) => string[];
  extractFields: (documentFileId: string, templateId?: string) => void;
  deleteTemplate: (templateId: number) => void;
  showSnackbar: (message: string, severity?: 'success' | 'error') => void;
  extractingFields: boolean;
}

const TemplateGroup: React.FC<TemplateGroupProps> = ({
  type,
  templates,
  documents,
  parseExtractedFields,
  extractFields,
  deleteTemplate,
  showSnackbar,
  extractingFields,
}) => {
  return (
    <Accordion key={type} defaultExpanded sx={{ mb: 2 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6">{formatTemplateType(type)}</Typography>
        <Chip 
          label={`${templates.length} template${templates.length !== 1 ? 's' : ''}`} 
          size="small" 
          sx={{ ml: 2 }} 
        />
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
          {templates.map(template => {
            const document = documents.find(d => d.fileID === template.documentFileId);
            const fields = parseExtractedFields(template.extractedFields);
            
            return (
              <TemplateCard
                key={template.id}
                template={template}
                document={document}
                fields={fields}
                extractFields={extractFields}
                deleteTemplate={deleteTemplate}
                showSnackbar={showSnackbar}
                extractingFields={extractingFields}
              />
            );
          })}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default TemplateGroup;
